import React, { useMemo } from 'react'
import CurrencyInputBase, { InputProps as CurrencyInputProps } from 'react-currency-input-field'
import { getCurrencyInfo } from '@helpers/utils'

export type InputProps = CurrencyInputProps & {
  currency?: string
  isCurrency?: boolean
}

const DEFAULT_SCALE = 2
const DEFAULT_LIMIT = 2

export const CurrencyInput: React.FC<InputProps> = (props) => {
  const { currency, isCurrency, decimalScale: decimalScaleProp, decimalsLimit: decimalsLimitProp, ...rest } = props

  const info = useMemo(() => {
    const handleAsCurrency = isCurrency ?? true
    let decimalScale = handleAsCurrency ? DEFAULT_SCALE : decimalScaleProp
    let decimalsLimit = handleAsCurrency ? DEFAULT_LIMIT : decimalsLimitProp

    if (!currency) return { decimalScale, decimalsLimit }

    const { hasDecimal } = getCurrencyInfo(currency)

    if (!hasDecimal) {
      decimalScale = 0
      decimalsLimit = 0
    }

    return { decimalScale, decimalsLimit }
  }, [currency])

  return (
    <CurrencyInputBase
      decimalSeparator="."
      groupSeparator=","
      intlConfig={{
        locale: 'en-US',
        currency: isCurrency ? currency : undefined,
      }}
      decimalScale={info.decimalScale}
      decimalsLimit={info.decimalsLimit}
      {...rest}
    />
  )
}

export default React.memo(CurrencyInput)
